import { apiClient } from '@/shared/api';
import { ServiceTokenCreateRequest, ServiceTokenCreateResponse, ServiceTokenListResponse } from './types';

/**
 * Fetch service tokens for a user per OpenAPI GET /user/{userId}/service-token
 */
export const fetchServiceTokens = async (userId: number, params?: { isActive?: boolean }) => {
  const { data } = await apiClient.get<ServiceTokenListResponse>(`/user/${userId}/service-token`, { params });
  return data;
};

/**
 * Create a service token per OpenAPI POST /user/{userId}/service-token
 */
export const createServiceToken = async (userId: number, payload: ServiceTokenCreateRequest) => {
  const { data } = await apiClient.post<ServiceTokenCreateResponse>(`/user/${userId}/service-token`, payload);
  return data;
};

/**
 * Revoke a service token per OpenAPI DELETE /user/{userId}/service-token/{tokenId}
 */
export const revokeServiceToken = async (userId: number, tokenId: number) => {
  await apiClient.delete(`/user/${userId}/service-token/${tokenId}`);
};
